import { fadeIn, scaleUp } from '../../Styles/keyframes'
import { createAnimation, styled } from '../../Styles/stitches.config'
import { StyledSVG } from '../SVG/styles'

export const StyledCloseIcon = styled('div', {
    br: '50%',
    cursor: 'pointer',
    display: 'grid',
    p: '$2',
    placeItems: 'center',
    position: 'absolute',
    right: 8,
    transition: '$default',

    [`& > ${StyledSVG}`]: {
        size: 12,
    },
})

export const StyledSnackbar = styled('div', {
    ...createAnimation([fadeIn, scaleUp]),
    bottom: '$3',
    br: '$1',
    color: '$white',
    display: 'flex',
    fontWeight: 600,
    gap: '$3',
    left: '$3',
    p: '$2 $3',
    placeItems: 'center',
    position: 'fixed',
    pr: 48,
    transition: '$default',
    zIndex: '$fixed',

    variants: {
        action: {
            error: {
                bgc: '$error600',

                [`& ${StyledCloseIcon}`]: {
                    '&:hover': {
                        bgc: '$error500',
                    },
                },
            },
            information: {
                bgc: '$primary500',

                [`& ${StyledCloseIcon}`]: {
                    '&:hover': {
                        bgc: '$primary400',
                    },
                },
            },
            success: {
                bgc: '$secondary600',

                [`& ${StyledCloseIcon}`]: {
                    '&:hover': {
                        bgc: '$secondary500',
                    },
                },
            },
        },
        isOpen: {
            true: {
                opacity: 1,
            },
            false: {
                opacity: 0,
            },
        },
    },
})
